import styled from 'styled-components';

export const StyledStepperWrapper = styled.div<{ 'data-id': string }>`
  header > div > h1 {
    height: 0;
    width: 0;
    overflow: auto;
  }
`;
